import { useMemo } from 'react';
import { MantineTable } from '@dealstack/frontend/shared/components/Table/MantineTable/MantineTable.tsx';
import { useMantineTableDataOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableDataOperations.ts';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { InvestmentDetailsLegalDocument } from '@dealstack/shared/lib/generated';
import { getInvestmentLegalDocumentsTableColumns } from './investmentLegalDocumentsTable.utils.tsx';

interface Props {
	legalDocuments: InvestmentDetailsLegalDocument[];
	onUnassignedSignerClick?: (documentId: string) => void;
}

export const InvestmentLegalDocumentsTable = ({
	legalDocuments,
	onUnassignedSignerClick,
}: Props) => {
	const tMipManage = useTranslationMipManage();
	const dataOperations = useMantineTableDataOperations();

	const columns = useMemo(
		() => getInvestmentLegalDocumentsTableColumns({ tMipManage, onUnassignedSignerClick }),
		[tMipManage, onUnassignedSignerClick]
	);

	return (
		<MantineTable
			columns={columns}
			data={legalDocuments}
			dataOperations={dataOperations}
			manualFiltering={false}
			manualSorting={false}
			enableTopToolbar={false}
			enablePagination={false}
			hideBorders={true}
		/>
	);
};
